import React from 'react';

import { observer } from 'mobx-react';

import { useLocale } from '@react-aria/i18n';
import { useNumberField } from '@react-aria/numberfield';

import { useNumberFieldState } from '@react-stately/numberfield';

import type { AriaNumberFieldProps } from '@react-types/numberfield';

import ClickFieldError from '../common/error';
import type { IProps as IClickFieldErrorProps } from '../common/error';
import ClickFieldInputContainer from '../common/input-container';
import ClickFieldLabel from '../common/label';
import type { IProps as IClickFieldLabelProps } from '../common/label';

export interface IProps extends AriaNumberFieldProps {
  className?: string;
  inputContainerClass?: string;
  required?: boolean;
  submitted?: boolean;

  errorTextClassName?: IClickFieldErrorProps['className'];
  errorText?: IClickFieldErrorProps['value'];

  labelClassName?: IClickFieldLabelProps['className'];
}

const NumberField: React.FC<IProps> = observer((props) => {
  const {
    className,
    errorText,
    errorTextClassName,
    inputContainerClass,
    label,
    labelClassName,
    required,
    submitted
  } = props;

  const inputRef = React.useRef<HTMLInputElement>(null);

  const { locale } = useLocale();
  const state = useNumberFieldState({ ...props, locale });
  const numberfield = useNumberField(props, state, inputRef);
  const { labelProps, inputProps } = numberfield;
  return (
    <div className="field-container">
      {label && (
        <ClickFieldLabel
          {...labelProps.bzOmit('onReset')}
          className={labelClassName}
          label={label}
          required={required}
        />
      )}
      <ClickFieldInputContainer className={inputContainerClass}>
        <input
          {...inputProps}
          ref={inputRef}
          className={`click-input ${className ?? ''}`}
          placeholder={props.placeholder}
        />
        {!!errorText && submitted && (
          <ClickFieldError className={errorTextClassName} value={errorText} />
        )}
      </ClickFieldInputContainer>
    </div>
  );
});

NumberField.displayName = 'NumberField';

export default NumberField;
